export const widgets = {
  // main routes
  homePage: "0e87350d-a80c-4a15-b6f0-6c3ead59373d",

  // directions routes
  reportPage: "2c02f972-b64b-465a-a43c-230495aadd4c",
  accountingPage: "910d0e28-47ac-4188-ad95-f27f9c6f1a1f",
  crmPage: "47315cc8-d7b9-4372-86a1-ff5da18a98ea",
  edoPage: "4b4bb52e-6847-40b8-988f-c51f52a46a3a",
  kaEdoPage: "fd3d8101-ff96-41e1-8def-d2b73893bc0b",
  ediPage: "7401f32b-06ff-4eb3-ab11-7a2b34fab4d9",
  controlBusinessProccessesPage: "1dac9492-7c99-45e4-842b-17f19d38c068",
  internationalEdoPage: "9ce62ef5-9f5b-4cf6-b0cf-003bcf4fc788",
  eplPage: "0ec63e20-1b85-499b-95df-fe1c71cf3f23",
  eTrNPage: "f082c1bb-4766-45ce-a98d-00a826650528",
  ofdPage:"7bb4e0d4-8171-485b-a759-7422e807f4e1",
  automationBusinessPage:"38eea4a3-a3c6-4574-accd-c5b0d126d7f7",
  marketAndOnlineSalePage:"f90d50bd-bfbe-4999-b3d6-531b970fd42e",
  restaurantCafeBistroPage:"904eccb7-5fbe-4432-926b-a8954da36680",
  salonAndServiceSectorPage:"0c50afba-f5ae-41c8-a23c-163dfc0b80cf",
  tradeAndProductionPage:"5f1e401a-8c43-4580-a105-8a3e87da6a41",
  mobileStaffPage:"4c56c197-f23c-477b-abc7-f040d4809c0b",
  videoControlPage:"8fa2ccbf-5405-416f-a4c7-a8f6e5b98be7",
  exchangeWithGovPage:"381efce6-af18-4c57-a6da-460f50e3f50a",
  cloudTelephonyPage:"6247aabb-6d13-4823-a240-6c496967dfe3",
  aboutCompaniesPage:"7cfc3456-dde2-4e2f-8b46-a4efc18a5abb",
  tendersAndPurchasesPage:"cc210e82-a1df-40f3-a680-a13840d484c2",
  personalControlPage:"1ecd67c4-2ced-4d76-b491-8b17f05cf27f",
  personalEDOPage:"1905551f-109b-4f69-8c0d-2464a7b81adc",
  salaryAndPersonnelPage:"f6fbd0ac-9192-4ce3-a228-feb36c912bd4",
  militaryRegistrationPage:"4cee008f-48d8-4bdd-b3bb-61685960cfa2",
  controlWorkingTime:"d1d32e4e-fd14-4d40-b1d7-0c61cfc3acb7",
  recruitmentOfPersonnelPage:"4f259d7f-e713-47e9-bcd8-73bf40929e9a",
  kpiAndMotivationPage:"9dcaee63-0346-45e0-9f8b-f71da7d5f954",
  corporatePortalPage:"77fc9007-4cce-495c-a443-e89abc8976c3",
  webinarsAndCommunicationsPage:"924f86d5-d15e-42c6-a900-337fdba2e115",

  // ecp routes
  ecpPage: "9a12c8cc-8dac-43d6-b1e8-119fbbde52db",
  mchdPage: "e2c936e5-01f2-4730-82ab-a4d69691ebf1",
  corpUcPage: "/korporativnyj-uc",
  logisticsPage: "5d190e63-503d-4156-8826-b9c7838f303e",
}